import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FundListService } from 'src/app/services/fund-list.service';
import { PerformanceInvestmentService } from 'src/app/services/performance-investment.service';
import { PerformanceCalculationService } from 'src/app/services/performance-calculation.service';
import { FundService } from 'src/app/services/fund.service';
import { NewsService } from 'src/app/services/news.service';
import { MainService } from 'src/app/services/main.service';
import { Router } from '@angular/router';
import postscribe from 'postscribe';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import 'dotdotdot-js'
import { UUID } from 'angular2-uuid';
import { CookieService } from '../../../../node_modules/ngx-cookie-service';
import 'bootstrap';
import * as $ from 'jquery';
import { mobileMaxScreen } from 'src/app/constants/constants';

@Component({
    selector: 'app-main-page',
    templateUrl: './main-page.component.html',
    styleUrls: ['./main-page.component.scss']
})
export class MainPageComponent implements OnInit, AfterViewInit, PipeTransform {
    @ViewChild('scrollTo') scrollTo: ElementRef
    @ViewChildren('dot') dot: QueryList<ElementRef>
    language = JSON.parse(localStorage.getItem('language'))

    showReport = false;
    selectedContent = {}
    selectedIndex = 0;
    selectedIndexCheck = [];
    selectedType = 'filter'
    selectListDropdown = []
    dropdownTitle = 'เลือกกองทุน'
    performanceReportPlaceholder = "วันที่ลงทุน"
    sectionList = [
        {
            title: 'RECOMMENDED' + '\n' + 'FUND',
            icon: 'assets/images/icon/filter/icon-recommend@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-recommend_@2x.png',
            content: {
                type: 'Recommend Fund',
                header: '',
                description: '',
                list: []
            }
        },
        {
            title: 'ALL',
            icon: 'assets/images/icon/filter/icon-all@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-all_@2x.png',
            content: {
                type: 'All',
                header: '',
                description: '',
                list: []
            }
        },
        {
            title: this.language.menutitlebar1,
            icon: 'assets/images/icon/filter/icon-reit@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-reit_@2x.png',
            content: {
                type: 'Real Estate Investment Trust',
                header: this.language.menutitlebar1,
                description: '',
                list: []
            }
        },
        {
            title: this.language.menutitlebar2,
            icon: 'assets/images/icon/filter/icon-mm@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-mm_@2x.png',
            content: {
                type: 'Money Market Fund',
                header: this.language.menutitlebar2,
                // tslint:disable-next-line:max-line-length
                description: 'กองทุนที่เรานำเงินไปลงทุนในตราสารหนี้ที่มีความมั่นคง มีสภาพคล่องสูง เช่น เงินฝาก ตราสารหนี้ภาครัฐ ตราสารหนี้สถาบันการเงิน กองทุนรวมตลาดเงินเหมาะสำหรับผู้ลงทุนที่ต้องการลงทุนในระยะสั้น และยอมรับความเสี่ยงจากการลงทุนที่ได้รับผลตอบแทนต่ำ',
                list: []
            }
        },
        {
            title: this.language.menutitlebar3,
            icon: 'assets/images/icon/filter/icon-eq@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-eq_@2x.png',
            content: {
                type: 'Equity Fund',
                header: this.language.menutitlebar3,
                description: 'กองทุนรวมที่เน้นลงทุนในหุ้นจดทะเบียนที่มีปัจจัยพื้นฐานดี และมีแนวโน้มการเติบโตสูง มีโอกาสได้รับผลตอบแทนสูง เหมาะสำหรับผู้ลงทุนที่ต้องการผลตอบแทนในระดับสูง และยอมรับความเสี่ยงจากการปรับตัวผันผวนของกองทุนได้',
                list: []
            }
        },
        {
            title: this.language.menutitlebar4,
            icon: 'assets/images/icon/filter/icon-fl@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-fl_@2x.png',
            content: {
                type: 'Fixed Income Fund',
                header: this.language.menutitlebar4,
                description: 'กองทุนตราสารหนี้ เป็นการลงทุนในตราสารหนี้ เช่น พันธบัตรรัฐบาล ตั๋วสัญญาใช้เงิน ตั๋วแลกเงิน หุ้นกู้ และเงินฝากธนาคาร เหมาะสำหรับผู้ลงทุนที่รับความเสี่ยงได้ต่ำ โดยผู้ลงทุนสามารถเลือกรูปแบบของกองทุนตราสารหนี้ที่เหมาะสมกับตนเอง',
                list: []
            }
        },
        {
            title: this.language.menutitlebar5,
            icon: 'assets/images/icon/filter/icon-rof@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-rof_@2x.png',
            content: {
                type: 'Rollover Fund',
                header: this.language.menutitlebar5,
                description: 'กองทุนรวมตราสารหนี้แบบกำหนดระยะเวลาลงทุน',
                list: []
            }
        },
        {
            title: this.language.menutitlebar6,
            icon: 'assets/images/icon/filter/icon-mf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-mf_@2x.png',
            content: {
                type: 'Mixed Fund',
                header: this.language.menutitlebar6,
                description: 'กองทุนผสม (Mixed Fund) คือ กองทุนที่กระจายการลงทุนในหลักทรัพย์หลายประเภท เช่น ตราสารหนี้ ตราสารทุน ตราสารอนุพันธ์ ในสัดส่วนการลงทุนที่เหมาะสม (Asset Allocation) กับภาวะการลงทุนในแต่ละช่วง หรืออยู่ในกรอบที่นโยบายการลงทุนกำหนด โดยมีรูปแบบการลงทุนที่หลากหลาย',
                list: []
            }
        },
        {
            title: this.language.menutitlebar7,
            icon: 'assets/images/icon/filter/icon-gef@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-gef_@2x.png',
            content: {
                type: 'Global Equity Fund',
                header: this.language.menutitlebar7,
                description: 'กองทุนรวมที่เน้นลงทุนในหุ้นจดทะเบียนที่มีปัจจัยพื้นฐานดี และมีแนวโน้มการเติบโตสูง มีโอกาสได้รับผลตอบแทนสูง เหมาะสำหรับผู้ลงทุนที่ต้องการผลตอบแทนในระดับสูง และยอมรับความเสี่ยงจากการปรับตัวผันผวนของกองทุนได้',
                list: []
            }
        },
        {
            title: this.language.menutitlebar8,
            icon: 'assets/images/icon/filter/icon-gfi@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-gfi_@2x.png',
            content: {
                type: 'Global Fixed Income Fund',
                header: this.language.menutitlebar8,
                description: 'ช่องทางการกระจายการลงทุนในสินทรัพย์ต่างประเทศ มีนโยบายการลงทุนหลากหลาย',
                list: []
            }
        },
        {
            title: this.language.menutitlebar9,
            icon: 'assets/images/icon/filter/icon-gmf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-gmf_@2x.png',
            content: {
                type: 'Global Mixed Fund',
                header: this.language.menutitlebar9,
                description: 'กองทุนที่กระจายการลงทุนในหลักทรัพย์หลายประเภท เช่น ตราสารหนี้ ตราสารทุน ตราสารอนุพันธ์ ในสัดส่วนการลงทุนที่เหมาะสม (Asset Allocation) กับภาวะการลงทุนในแต่ละช่วง หรืออยู่ในกรอบที่นโยบายการลงทุนกำหนด โดยมีรูปแบบการลงทุนที่หลากหลาย',
                list: []
            }
        },
        {
            title: this.language.menutitlebar10,
            icon: 'assets/images/icon/filter/icon-etf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-etf_@2x.png',
            content: {
                type: 'Exchange Traded Fund (ETF)',
                header: this.language.menutitlebar10,
                description: 'กองทุนเปิดที่จดทะเบียนในตลาดหลักทรัพย์ มีนโยบายการลงทุน มุ่งเน้นให้ได้ผลตอบแทนที่ใกล้เคียง หรือเทียบเท่ากับดัชนีที่ใช้อ้างอิง (underlying index) เช่น ดัชนีหลักทรัพย์ ราคาทองคำ เป็นต้น ผู้ลงทุนสามารถซื้อขายเหมือนการซื้อขายหุ้นในตลาดหลักทรัพย์ 1. กองทุนเปิดไทยเด็กซ์เซ็ท 50 อีทีเอฟ (TDEX) มุ่งสร้างผลตอบแทนให้ใกล้เคียงกับดัชนี SET50 Index 2. กองทุนเปิดไทยเด็กซ์เซ็ท 100 อีทีเอฟ (TH100) มุ่งสร้างผลตอบแทนให้ใกล้เคียงกับดัชนี SET100 Index 3. กองทุนเปิดไทยเด็กซ์ SET High Dividend ETF (1DIV) ลงทุนในหลักทรัพย์ที่เป็นส่วนประกอบของดัชนี SET High Dividend 30 Index เพื่อสร้างผลตอบแทนใกล้เคียงกับดัขนี 4. กองทุนเปิด วรรณ STOXX อาเซียน ซีเล็ค ดิวิเดนด์ อินเด็กซ์ ฟันด์ (ONE-STOXXASEAN) มุ่งสร้างผลตอบแทนที่ดีให้ใกล้เคียงกับดัชนี STOXX ASEAN SELECT DIVIDEND 30 INDEX โดยกองทุนอยู่ภายใต้โครงการ ASEAN CIS และจะปฏิบัติตามเกณฑ์ที่กำหนดใน Standards of Qualifying CIS ของ Memorandum of Understanding on Streamlined Authorisation Framework for Cross-border Public Offers of ASEAN Collective Investment Schemes',
                list: []
            }
        },
        {
            title: this.language.menutitlebar11,
            icon: 'assets/images/icon/filter/icon-ltf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-ltf_@2x.png',
            content: {
                type: 'Long-Term Equity Fund (LTF)',
                header: 'กองทุนรวมหุ้นระยะยาว',
                description: 'เหมาะสำหรับผู้ลงทุนที่หวังผลในระยะยาว กับการลงทุนที่มีแต้มต่อ จากสิทธิประโยชน์ทางภาษี ประหยัดภาษี 2 ต่อ ทั้งลดหย่อนเงินได้พึงประเมิน และยกเว้นภาษีเงินได้จากการลงทุน',
                list: []
            }
        },
        {
            title: this.language.menutitlebar12,
            icon: 'assets/images/icon/filter/icon-rmf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-rmf_@2x.png',
            content: {
                type: 'Retirement Mutual Fund (RMF)',
                header: 'กองทุนรวมเพื่อการเลี้ยงชีพ',
                description: 'กองทุนที่ผู้มีรายได้สามารถเลือกลงทุนเพื่อสะสมเงินไว้ใช้หลังวัยเกษียณ และได้รับสิทธิประโยชน์การลดหย่อนทางภาษีจากรัฐเป็นแรงจูงใจ เหมาะสำหรับผู้ลงทุนที่ต้องการวางแผนการเงิน เพื่อความมั่นคงของชีวิตในวัยเกษียณ',
                list: []
            }
        },
        {
            title: this.language.menutitlebar13,
            icon: 'assets/images/icon/filter/icon-sf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-sf_@2x.png',
            content: {
                type: 'Sector Fund',
                header: this.language.menutitlebar13,
                description: 'กองทุนรวมประเภทที่เน้นลงทุนในกลุ่มอุตสาหกรรมใดอุตสาหกรรมหนึ่งเป็นหลัก เช่น กลุ่มธุรกิจอสังหาริมทรัพย์ ทำให้การลงทุนมีความกระจุกตัวค่อนข้างสูง เหมาะสำหรับผู้ลงทุนที่สามารถรับความเสี่ยงได้สูง',
                list: []
            }
        },
        {
            title: this.language.menutitlebar14,
            icon: 'assets/images/icon/filter/icon-cdf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-cdf_@2x.png',
            content: {
                type: 'Commodity Fund',
                header: this.language.menutitlebar14,
                description: this.language.menutitlebar14,
                list: []
            }
        },
        {
            title: this.language.menutitlebar15,
            icon: 'assets/images/icon/filter/icon-cf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-cf_@2x.png',
            content: {
                type: 'Country Fund',
                header: this.language.menutitlebar15,
                description: 'กองทุนรวมที่มีทุนมาจากต่างประเทศ Country Fund',
                list: []
            }
        },
        {
            title: this.language.menutitlebar16,
            icon: 'assets/images/icon/filter/icon-pf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-pf_@2x.png',
            content: {
                type: 'Property Fund',
                header: this.language.menutitlebar16,
                description: 'กองทุนรวมที่นำเงินที่ได้จากการจำหน่ายหน่วยลงทุน ไปซื้อหรือเช่าอสังหาริมทรัพย์ และจัดหาผลประโยชน์จากอสังหาริมทรัพย์นั้นโดยการนำไปให้เช่าอสังหาริมทรัพย์ที่ลงทุน อาจจะเป็นสำนักงาน ที่พักอาศัย ศูนย์การค้า โรงแรม โรงงาน โกดังเก็บสินค้า ฯลฯ โดยจะมีการระบุไว้ในนโยบายการลงทุนของแต่ละกองทุน โดยเสนอขายหน่วยลงทุนในช่วงแรกให้กับประชาชนและผู้ลงทุนทั่วไป (Public Offering) และจะนำหน่วยลงทุนไปจดทะเบียนในตลาดหลักทรัพย์แห่งประเทศไทย เพื่อเพิ่มสภาพคล่องให้แก่ผู้ลงทุน เหมาะกับผู้ลงทุนที่ไม่สามารถใช้เงินลงทุนจำนวนมากไปลงทุนในอสังหาริมทรัพย์เพื่อเก็บค่าเช่าได้ด้วยตัวเอง ให้สามารถลงทุนด้วยเงินจำนวนน้อยกว่า เพื่อเก็บรายได้ค่าเช่าแล้วคืนให้กับผู้ถือหน่วยในรูปของเงินปันผล',
                list: []
            }
        },
        {
            title: this.language.menutitlebar17,
            icon: 'assets/images/icon/filter/icon-ssf@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-ssf_@2x.png',
            content: {
                type: 'Super Savings Fund (SSF)',
                header: this.language.menutitlebar17,
                description: 'กองทุนรวมที่มีวัตถุประสงค์ในการส่งเสริมการออมระยะยาวของผู้ลงทุน และหมายความรวมถึงกองทุนรวมที่มีการแบ่งชนิดของหน่วยลงทุนตามกรณีสิทธิประโยชน์ทางภาษี  ซึ่งผู้ถือหน่วยลงทุนจะได้รับสิทธิประโยชน์ทางภาษีเมื่อผู้ลงทุนซื้อหน่วยลงทุน และปฏิบัติตามหลักเกณฑ์ วิธีการ และเงื่อนไข ตามที่กรมสรรพากร และ/หรือ กฎหมายอื่นใดที่เกี่ยวข้องกำหนด',
                list: []
            }
        },
        {
            title: this.language.menutitlebar18,
            icon: 'assets/images/icon/filter/icon-thaiesg@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-thaiesg_@2x.png',
            content: {
                type: 'Thailand ESG Fund',
                header: this.language.menutitlebar18,
                description: '',
                list: []
            }
        },
        {
            title: this.language.menutitlebar19,
            icon: 'assets/images/icon/filter/icon-ot@2x.png',
            activeIcon: 'assets/images/icon/filter/icon-ot_@2x.png',
            content: {
                type: 'Other Fund',
                header: this.language.menutitlebar19,
                description: '',
                list: []
            }
        },
    ]

    date: string
    date2: string

    displayDate: any
    displayTime: any
    // Fund Get List
    fundList: any
    // fundList: Array<Object> = [];
    fundCode = []
    fundId: number
    fundId2: number

    // IIV fund
    iivFund: any

    // Performance Investment
    investPeriod: string
    investPortfolioCode: string
    investBenchmark: string
    investSd: string
    investSDBenchmark: string
    // data performance reports
    dataPerformanceReports: Array<Object> = []
    investNoteList: any;
    investNoteTitle: Array<Object> = []
    investNote: Array<Object> = []

    // Performance Calculation
    // table 1
    portPerformance = []
    portSDPerformance = []
    portBenchmarkObject: object
    portSDBenchmarkObject: object
    portBenchmarkPerformance = []
    portSDBenchmarkPerformance = []
    portPerfNoteTitle: string
    portPerfNote: Array<Object> = []

    // table 2
    returnPerfYear = []
    returnPortPerf = []
    returnPortSDPerf = []
    returnPortBenchObj: object
    returnPortSDBenchObj: object
    returnPortBenchmark = []
    returnPortSDBenchmark = []

    // grid fund
    // recommendedFunds: Array<Object> = []
    recommendedFunds: any;
    // fund type
    fundTypeId: string
    // fundListArray: Array<Object> = []
    fundListArray: any
    // filterFundList: Array<Object> = []
    filterFundList: any;// Array<Object> = []
    selectedFundType: string
    // grid fund page count
    totalPageCount: number
    currentPage: number = 1

    //news
    news: any
    newsDate: any
    announces: any
    eartupdate: any;
    promotion: any;
    fundrecomm: any;
    banner: any;
    searchFund: any;
    invalidPerfInvest: boolean = false
    invalidFundPerf: boolean = false
    ipAddress: any;
    uuidValue: any;
    flag: any
    isMobile: boolean = false;

    constructor(private _fundListService: FundListService,
        private _performanceInvestService: PerformanceInvestmentService,
        private _performanceCalService: PerformanceCalculationService,
        private _fundService: FundService,
        private _newsService: NewsService,
        private ngxService: NgxUiLoaderService,
        private _mainService: MainService,
        private router: Router,
        private http: HttpClient,
        private _sanitizer: DomSanitizer,
        private cookieService: CookieService) {
        // this.http.get<{ ip: string }>('https://jsonip.com')
        //   .subscribe(data => {
        //     this.ipAddress = data.ip
        //   })
    }

    getBackground(image) {
        return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
    }

    onSelectedContent(content, index) {
        this.selectedIndex = index;
        this.checkAll(content);
        this.filterFuntype(content.type);

    }

    checkAll(content) {
        if (content.type === 'All') {
            this.selectedIndexCheck = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,18,20];
        } else {
            this.selectedIndexCheck = [];
        }
    }

    checkAllAgain(index) {
        if (this.selectedIndexCheck.length > 0) {
            let status = false;
            this.selectedIndexCheck.forEach(ic => {
                if (index === ic) {
                    status = true;
                }
            });
            return status;
        } else {
            if (this.selectedIndex === index) {
                return true;
            } else {
                return false;
            }
        }
    }

    ngOnInit() {
        if (window.screen.width <= mobileMaxScreen) { // 768px portrait
            this.isMobile = true;
        }

        this.flag = localStorage.getItem("language_flag")

        if (localStorage.getItem('uuid_') == null) {
            localStorage.setItem('uuid_', UUID.UUID());
        }

        this._fundListService.getFundList_2().subscribe(response => {
            this.fundList = response
            this.getFundCode(this.fundList)
        })

        this._newsService.getLatestNews_2(3).subscribe(response => {
            this.news = response
        })

        this._mainService.getAnnounce().subscribe(response => {
            this.announces = response;
        })

        this._mainService.getEartUpdate().subscribe(response => {
            this.eartupdate = response;
        })

        this._mainService.getPromotion().subscribe(response => {
            this.promotion = response;
        })

        this._mainService.getFundRecomm().subscribe(response => {
            this.fundrecomm = response;
        })
        this._mainService.getBanner().subscribe(response => {
            this.banner = response;
        })
        this._fundService.getIIV().subscribe(response => {
            this.iivFund = response['Result']
        })
        this.displayDate = this.transform(new Date())
        this.displayTime = new Date().toTimeString().substr(0, 5)
    }

    ngAfterViewInit() {
        ($('.carousel') as any).carousel();

        postscribe('#oil',
            '<script type="text/javascript" src="https://www.oil-price.net/widgets/brent_crude_price_large/gen.php?lang=en"></script>',
            { autofix: false });

        postscribe('#gold',
            '<script type="text/javascript" src="https://www.gold-quote.net/TABLE2/gen.php?lang=en"> </script>',
            { autoFix: false })

        this.dot.changes.subscribe(() => {
            this.dot.toArray().forEach(el => {
                $(el.nativeElement).dotdotdot({
                    truncate: "letter",
                    watch: true,

                })
            })
        })
    }
    transform(value) {
        let datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, 'dd/MM/yyyy')
        return value
    }

    setFund(select) {
        sessionStorage.setItem('Fund', select)
    }

    filterFuntype(type) {
        this.currentPage = 1;
        this.selectedFundType = type
        if (type === 'All') {
            this.fundTypeId = ""
            this._fundService.getAllFund().subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Real Estate Investment Trust') {
            this.fundTypeId = "16"

            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Money Market Fund') {
            this.fundTypeId = "1"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Equity Fund') {
            this.fundTypeId = "2"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Fixed Income Fund') {
            this.fundTypeId = "3"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Rollover Fund') {
            this.fundTypeId = "12"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Mixed Fund') {
            this.fundTypeId = "4"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Global Equity Fund') {
            this.fundTypeId = "7"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Global Fixed Income Fund') {
            this.fundTypeId = "5"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Global Mixed Fund') {
            this.fundTypeId = "6"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Exchange Traded Fund (ETF)') {
            this.fundTypeId = "11"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Long-Term Equity Fund (LTF)') {
            this.fundTypeId = "9"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Retirement Mutual Fund (RMF)') {
            this.fundTypeId = "10"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Sector Fund') {
            this.fundTypeId = "13"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Commodity Fund') {
            this.fundTypeId = "8"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Country Fund') {
            this.fundTypeId = "14"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Property Fund') {
            this.fundTypeId = "15"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Super Savings Fund (SSF)') {
            this.fundTypeId = "17"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        }
        else if (type === 'Thailand ESG Fund') {
            this.fundTypeId = "18"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        }
        else if (type === 'Other Fund') {
            this.fundTypeId = "20"
            this._fundService.getFundByTypeId(this.fundTypeId).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)
            })
        } else if (type === 'Recommend Fund') {
            this.fundListArray = this.recommendedFunds
            this.totalPageCount = this.setTotalPage(this.fundListArray)
            this.setRenderPerPage(this.fundListArray)
        }
        
    }

    setTotalPage(objectFundType) {
        if (Object.keys(objectFundType).length <= 12) {
            return 1
        } else {
            return Math.ceil(Object.keys(objectFundType).length / 12)
        }
    }

    setRenderPerPage(fundList) {
        if (this.selectedFundType === undefined) {
            this._fundService.getTopFund().subscribe(response => {
                this.recommendedFunds = response
                this.totalPageCount = this.setTotalPage(this.recommendedFunds)
                this.filterFundList = this.recommendedFunds.slice(this.currentPage * 12 - 12, this.currentPage * 12)
                // this.scrollTo.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
            })
        } else {
            this.scrollTo.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
            this.filterFundList = fundList.slice(this.currentPage * 12 - 12, this.currentPage * 12)
        }
    }

    setCurrentPage($event) {
        this.currentPage = $event
        this.setRenderPerPage(this.fundListArray)
    }

    linkStoxx() {
        location.href = 'https://www.stoxx.com/index-details?symbol=SXAE3DGV&stoxxindex=sxae3dgv&searchTerm=stoxx+asean+select+dividend';
    }

    getFundCode(fundList: object) {
        Object.entries(fundList).forEach(
            ([key, value]) => {
                this.showFundCode(value)
            }
        );
    }

    showFundCode(fundCode) {
        this.selectListDropdown.push({ title: fundCode.fundCode, value: fundCode.fundId })
    }

    getFundIdFromSelect($event) {
        this.fundId = $event
    }

    getPickDate($event) {
        this.date = $event;
    }

    getFundIdFromSelect2($event) {
        this.fundId2 = $event
    }

    getPickDate2($event) {
        this.date2 = $event;
    }


    setValueSearch(search: string) {
        this.searchFund = search
    }

    setDate1(d1) {
        this.date = d1
    }

    setDate2(d2) {
        this.date2 = d2
    }

    clickCalculate(menuSelect) {

        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.fundId === undefined && (this.date === undefined || this.date === null)) {
            this.invalidPerfInvest = true
            document.getElementsByClassName("selectiongroup")[0].setAttribute("style", "border: 1px solid red")
        }
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.fundId !== undefined) {
            this.invalidPerfInvest = false
        }
        else {
            this.invalidPerfInvest = true
        }
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.date !== undefined) {
            document.getElementsByClassName("selectiongroup")[0].setAttribute("style", "border: 0px solid red")
        }
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && (this.date === null || this.date === undefined)) {
            document.getElementsByClassName("selectiongroup")[0].setAttribute("style", "border: 1px solid red")
        }


        // Performance Investment
        if (menuSelect === 'เครื่องคำนวณการลงทุน' && this.fundId !== undefined && this.date !== undefined && this.date !== null) {
            this.ngxService.start();
            this.dataPerformanceReports = []
            this.investNoteTitle = []
            this._performanceInvestService.getPerformanceInvest(this.fundId, this.date).subscribe(response => {
                let i = 2;
                response['Result']['benchmarkList'].map(m => {
                    i++;
                    this.dataPerformanceReports.push(
                        {
                            index: i,
                            value: m['nameshort'],
                            percent: m['INDEX_P1']
                        }
                    );
                });
                this.investPeriod = response["Result"]["performance"]["p1"]
                this.investPortfolioCode = response["Result"]["performance"]["portfolioCode"]
                this.investBenchmark = response["Result"]["performance"]["NAV_P1"]
                this.investSd = response["Result"]["performance"]["sd"]
                this.investSDBenchmark = response["Result"]["performance"]["SD_P1"]
                let j = 0
                response["Result"]["noteList"].forEach(element => {
                    j++
                    this.investNoteTitle.push(
                        {
                            index: j,
                            noteTitle: element['nameshort'],
                            noteDetail: element['arrayName']
                        }
                    )
                });
                this.ngxService.stop();
                $('#perModal').modal('show');
            })
        }
    }


    clickCalculate2(menuSelect) {

        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.fundId2 === undefined && (this.date2 === undefined || this.date2 === null)) {
            this.invalidFundPerf = true
            document.getElementsByClassName("selectiongroup")[1].setAttribute("style", "border: 1px solid red")
        }

        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.fundId2 !== undefined) {
            this.invalidFundPerf = false
        } else {
            this.invalidFundPerf = true
        }
        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.date2 !== undefined) {
            document.getElementsByClassName("selectiongroup")[1].setAttribute("style", "border: 0px solid red")
        }
        if (menuSelect === 'ผลการดำเนินงานกองทุน' && (this.date2 === null || this.date2 === undefined)) {
            document.getElementsByClassName("selectiongroup")[1].setAttribute("style", "border: 1px solid red")
        }

        if (menuSelect === 'ผลการดำเนินงานกองทุน' && this.fundId2 !== undefined && this.date2 !== undefined && this.date2 !== null) {
            this.ngxService.start();
            // clear data
            this.portPerformance = []
            this.portSDPerformance = []
            this.portBenchmarkPerformance = []
            this.portSDBenchmarkPerformance = []
            this.returnPerfYear = []
            this.returnPortPerf = []
            this.returnPortSDPerf = []
            this.returnPortBenchmark = []
            this.returnPortSDBenchmark = []

            this._performanceCalService.getPerformanceSum(this.fundId2, this.date2).subscribe(response => {
                console.log(response);
                if (response['Success'] === true || response['Success'] == true) {
                    // table 1
                    // row 1
                    this.portPerformance.push(response["Result"]["performance"]["portfolioCode"])
                    this.portPerformance.push(response["Result"]["performance"]["dataYTD"])
                    this.portPerformance.push(response["Result"]["performance"]["data3M"])
                    this.portPerformance.push(response["Result"]["performance"]["data6M"])
                    this.portPerformance.push(response["Result"]["performance"]["data1Y"])
                    this.portPerformance.push(response["Result"]["performance"]["data3Y"])
                    this.portPerformance.push(response["Result"]["performance"]["data5Y"])
                    this.portPerformance.push(response["Result"]["performance"]["data10Y"])
                    this.portPerformance.push(response["Result"]["performance"]["dataSinceInception"])

                    // row 2
                    this.portSDPerformance.push(response["Result"]["performance"]["sd"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSDYTD"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSD3M"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSD6M"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSD1Y"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSD3Y"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSD5Y"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSD10Y"])
                    this.portSDPerformance.push(response["Result"]["performance"]["dataSDSinceInception"])

                    // row 3
                    this.portBenchmarkObject = response["Result"]["benchmarkList"].find(value => value.nameshort == "Benchmark 1")
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["nameshort"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P1"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P3"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P4"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P5"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P6"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P7"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P8"])
                    this.portBenchmarkPerformance.push(this.portBenchmarkObject["INDEX_P9"])

                    // row 4
                    this.portSDBenchmarkObject = response["Result"]["benchmarkList"].find(value => value.nameshort == "SD Benchmark 1")
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["nameshort"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P1"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P3"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P4"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P5"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P6"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P7"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P8"])
                    this.portSDBenchmarkPerformance.push(this.portSDBenchmarkObject["INDEX_P9"])

                    // note table 1
                    let i = 0
                    response["Result"]["noteList"].forEach(property => {
                        i++
                        this.portPerfNote.push(
                            {
                                index: i,
                                noteTitle: property["nameshort"],
                                noteDetail: property["arrayName"]
                            }
                        )
                        // this.portPerfNoteTitle = property["nameshort"]
                        // this.portPerfNote = property["arrayName"]
                    });

                    // table 2
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p1"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p2"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p3"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p4"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p5"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p6"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p7"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p8"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p9"])
                    this.returnPerfYear.push(response["Result"]["returnPerformance"]["p10"])

                    // row 1
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["portfolioCode"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P1"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P2"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P3"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P4"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P5"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P6"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P7"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P8"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P9"])
                    this.returnPortPerf.push(response["Result"]["returnPerformance"]["NAV_P10"])

                    // row 2
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["sd"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P1"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P2"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P3"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P4"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P5"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P6"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P7"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P8"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P9"])
                    this.returnPortSDPerf.push(response["Result"]["returnPerformance"]["SD_P10"])

                    // row 3
                    this.returnPortBenchObj = response["Result"]["returnBenchmarkList"].find(value => value.nameshort == "Benchmark 1")
                    this.returnPortBenchmark.push(this.returnPortBenchObj["nameshort"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P1"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P2"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P3"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P4"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P5"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P6"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P7"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P8"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P9"])
                    this.returnPortBenchmark.push(this.returnPortBenchObj["INDEX_P10"])

                    // row 4
                    this.returnPortSDBenchObj = response["Result"]["returnBenchmarkList"].find(value => value.nameshort == "SD Benchmark 1")
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["nameshort"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P1"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P2"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P3"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P4"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P5"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P6"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P7"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P8"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P9"])
                    this.returnPortSDBenchmark.push(this.returnPortSDBenchObj["INDEX_P10"])
                    $('#sumModal').modal('show');
                }
                else{
                    $('#warningModalForformanceSum').modal('show');
                }
                this.ngxService.stop();
            })
        }
    }

    changeFormatDate(date) {
        if (date === '') {
            return null
        } else {
            return this.newsDate = this._newsService.changeFormatDate(date)
        }
    }

    date_thai(date) {
        if (date === '') {
            return null
        } else {
            return this.newsDate = this._newsService.date_thai(date)
        }
    }

    clickEdit(banner_uri, banner_type, ref_id) {

        if (banner_uri !== '') {
            // this.router.navigate(banner_uri);
            window.open(banner_uri, '_self');
        } else if (banner_uri === '' && banner_type === 'news') {
            this.router.navigate(['/th/News/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'announce') {
            this.router.navigate(['/th/Announce/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'promotion') {
            this.router.navigate(['/th/Promotion/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'fundRecom') {
            this.router.navigate(['/th/fundrecomm/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'benefit') {
            this.router.navigate(['/th/Benefit/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'earthupdate') {
            this.router.navigate(['/th/EartUpdate/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'market') {
            this.router.navigate(['/th/market/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'goodgover') {
            this.router.navigate(['/th/goodgover/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'ethic') {
            this.router.navigate(['/th/ethic/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'corruption') {
            this.router.navigate(['/th/corruption/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'product') {
            this.router.navigate(['/th/product/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'managerList') {
            this.router.navigate(['/th/manager/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'transaction') {
            this.router.navigate(['/th/transaction/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'guideline') {
            this.router.navigate(['/th/guideline/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'vote') {
            this.router.navigate(['/th/vote/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'holding') {
            this.router.navigate(['/th/holding/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'vdo') {
            this.router.navigate(['/th/vdo/detail', ref_id]);
        } else if (banner_uri === '' && banner_type === 'newsletter') {
            this.router.navigate(['/th/newsletter/detail', ref_id]);
        }
    }

    keyDownFunction(event, search: string) {
        if (event.keyCode === 13) {
            this.searchFund = search;
            this.currentPage = 1;
            this.selectedFundType = 'All';
            this.fundTypeId = '';
            this._fundService.get_fundByName(this.searchFund).subscribe(response => {
                this.fundListArray = response
                this.totalPageCount = this.setTotalPage(this.fundListArray)
                this.setRenderPerPage(this.fundListArray)

            })
        }
    }

    onSearch() {
        this.currentPage = 1;
        this.selectedFundType = 'All';
        this.fundTypeId = '';
        this._fundService.get_fundByName(this.searchFund).subscribe(response => {
            this.fundListArray = response
            this.totalPageCount = this.setTotalPage(this.fundListArray)
            this.setRenderPerPage(this.fundListArray)
        })
    }

    // userclosesummain(){
    //     $('#warningModalFormanceSum_Main').modal('hide');
    // }

}
